import React, { useState, useEffect } from "react";
import "./CheckOut.css";
import { Container, Grid, InputLabel, Button } from "@mui/material";
import axios from "../../../../../Uri";
import ManagerPaymentsinPopup from "./managerPaymentModule/managerPaymentinPopUp";
import GuestpaymentsinPopUp from "./GuestPaymentModule/GuestpaymentsinPopUp";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import InitiateCheckoutBtn from "./InitiateCheckoutBtn";
var OccupancyType = null;
let userData = JSON.parse(sessionStorage.getItem("userdata"));
const isManager = userData?.data?.userType === "manager";

const CheckOut = (props) => {
  console.log(props);
  var guestdueamount = props.GuestDueAmount;
  OccupancyType = props.guestdetails.occupancyType;
  const [dates, setDates] = useState(null);
  const dt = null;
  const [disableCheckoutButtons, setDisableCheckoutButtons] =
    React.useState(false);
  const [pickNoticeDate, setPickNoticeDate] = useState(false);
  const initiateCheckoutProcess = () => {
    setPickNoticeDate(true);
  };
  const finalCheckOutHandler = async () => {
    if (props.guestdetails.dueAmount > 0) {
      props.func();
    } else {
      await axios
        .get(`guest/finalCheckout/${props.guestdetails.id}`)
        .then((res) => {
          setDisableCheckoutButtons(true);
          toast.success(
            "Guest Checked-Out Successfully. Please wait before we complete the transaction."
          );
        })
        .catch((err) => console.log(err));
    }
  };
  // console.log("day:", day, "month:", month, "year:", year);
const parseDate = (dateStr) => {
  const [day, month, year] = dateStr.split("-");
  const d = new Date(year, month - 1, day);
  d.setHours(0, 0, 0, 0);
  return d;
};

const today = new Date();
today.setHours(0, 0, 0, 0);

const plannedDate = props.guestdetails.plannedCheckOutDate
  ? parseDate(props.guestdetails.plannedCheckOutDate)
  : null;

const disableDueToDate = plannedDate && plannedDate < today;
console.log("today timestamp:", today.getTime());
console.log("planned timestamp:", plannedDate?.getTime());

console.log("Disable Button:", disableDueToDate);

  return (
    <div className="CheckOutComponent">
      <Grid container>
        {props.guestdetails.occupancyType == "Regular" &&
        props.guestdetails.guestStatus == "active" ? (
          <Grid xs={5} sx={{ pt: "30px", pr: "40px", mb: "20px", ml: "20px" }}>
            <Button
              disabled={disableCheckoutButtons}
              variant="contained"
              color="primary"
              onClick={initiateCheckoutProcess}
              style={{ color: "white" }}
            >
              INITIATE CHECKOUT
            </Button>
          </Grid>
        ) : (
          <div></div>
        )}
        {/* for the date picker to notice dates */}
        {pickNoticeDate === true ? (
          <>
            <InitiateCheckoutBtn guestdetails={props.guestdetails} />
          </>
        ) : (
          <></>
        )}
        {}
        {/* {props.guestdetails.guestStatus == "InNotice" ? (
          <Button
            disabled={disableCheckoutButtons || disableDueToDate}
            variant="contained"
            color="primary"
            style={{ margin: "12px",marginLeft:"44px" ,color: "white", float: "right" }}
            onClick={finalCheckOutHandler}
          >
            Finish CheckOut
          </Button>
        ) : (
          <div></div>
        )} */}

        {props.guestdetails.guestStatus == "InNotice" ? (
          (() => {
            const isButtonDisabled = disableCheckoutButtons || disableDueToDate;
            return (
              <>
                <Button
                  disabled={ disableDueToDate && isManager}
                  variant="contained"
                  color="primary"
                  style={{
                    margin: "12px",
                    marginLeft: "44px",
                    color: "white",
                    float: "right",
                  }}
                  onClick={finalCheckOutHandler}
                >
                  Finish CheckOut
                </Button>
              </>
            );
          })()
        ) : (
          <div></div>
        )}

        {
        props.guestdetails.occupancyType == "daily" ||
        props.guestdetails.occupancyType == "OneMonth" ? (
          <Button
            disabled={disableCheckoutButtons || disableDueToDate && isManager}
            className="btn-float-left"
            variant="contained"
            color="primary"
            style={{ margin: "20px", color: "white", float: "right" }}
            onClick={finalCheckOutHandler}
          >
            CheckOut
          </Button>
        ) : (
          <div></div>
        )}
      </Grid>
      {guestdueamount < 0 ? (
        <ManagerPaymentsinPopup guestdetails={props.guestdetails} />
      ) : (
        <div></div>
      )}
    {(guestdueamount > 0 ||
  (props.guestdetails.occupancyType === "Regular" && disableDueToDate)) ? (
  <GuestpaymentsinPopUp
    guestdetails={props.guestdetails}
    handleCloseGuestModalWindow={props.handleCloseGuestModalWindow}
  />
) : (
  <div></div>
)}
      <ToastContainer
        position="top-right"
        min-width="2%"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};
export default CheckOut;
